import { render, staticRenderFns } from "./buttonExtractionForRegion.vue?vue&type=template&id=09015e30&scoped=true&"
import script from "./buttonExtractionForRegion.vue?vue&type=script&lang=js&"
export * from "./buttonExtractionForRegion.vue?vue&type=script&lang=js&"
import style0 from "./buttonExtractionForRegion.vue?vue&type=style&index=0&id=09015e30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09015e30",
  null
  
)

export default component.exports